import { render, staticRenderFns } from "./LoyaltyCart.vue?vue&type=template&id=fa3031ec&scoped=true&"
import script from "./LoyaltyCart.vue?vue&type=script&lang=js&"
export * from "./LoyaltyCart.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyCart.vue?vue&type=style&index=0&id=fa3031ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3031ec",
  null
  
)

export default component.exports